<!-- 任务点排名 -->
<template>
  <div>
    <a-card v-show="loading" :loading="loading"><span /> </a-card>
    <a-card v-show="!loading" size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">任务独立交付率</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 开发完成时间</p>
            <p>描述: 所选时间段内各团队所负责任务的独立交付率，独立交付率 = 独立交付的任务数 / 任务总数</p>
            <p>&emsp;&emsp;&ensp;独立交付的任务：使用任务交付流程并上线交付的任务</p>
            <p>排序：独立交付率正序（默认）</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div id="task-delivery-alone-rate" :style="{ height: height, width: width }" />
    </a-card>
    <div v-if="data && data.length > 0 && data[index].tasks">
      <task-list-modal ref="taskListModal" :task-list="data[index].tasks" />
    </div>
  </div>
</template>
<script>
import { taskDeliveryAloneRate } from '@/api/data/task';
import TaskListModal from '@/pages/data/task/components/TaskListModal';
export default {
  components: { TaskListModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'team',
      loading: true,
      myChart: null,
      modalShow: false,
      index: 0,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: params => {
            let formatter = '<b>' + params[0].name + '</b><br/>';
            formatter += params[0].marker + params[0].seriesName + '<span style="float: right;><b style="color: #5A6FC0;">' + params[0].value + '</b> 条</span><br/>';
            formatter += params[1].marker + params[1].seriesName + '<span style="float: right; margin-left:16px""><b style="color: #9ECA7F;">' + params[1].value + '</b> 条</span><br/>';
            formatter += params[2].marker + params[2].seriesName + '<span style="float: right"><b style="color: #F2CA6B;">' + params[2].value + '</b> %</span><br/>';
            return formatter;
          }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '8%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: [
          {
            type: 'value',
            name: '数量'
          },
          {
            type: 'value',
            name: '独立交付率',
            axisTick: {
              show: false
            },
            axisLabel: {
              formatter: '{value}%'
            }
          }
        ],
        series: []
      },
      data: [],
      detailFilterForm: {},
      detailVisible: false
    };
  },
  watch: {
    filterForm() {
      this.getData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.myChart.resize();
      }, 200);
    }
  },
  mounted() {
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/chart/line');
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById('task-delivery-alone-rate'));
    const self = this;
    // this.myChart.getZr().on('click', param => {
    //   const pointInPixel = [param.offsetX, param.offsetY];
    //   // 判断给定的点是否在指定的坐标系或者系列上
    //   if (self.myChart.containPixel('grid', pointInPixel)) {
    //     // 获取到点击的 x轴 下标  转换为逻辑坐标
    //     const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
    //     self.onDetail(index);
    //   }
    // });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getData() {
      this.loading = true;
      taskDeliveryAloneRate({ ...this.filterForm, sorter: 'delivery_alone_rate', show_modal: this.showModal })
        .then(res => {
          this.data = res.data.items;
          const x_axis = [];
          const task_count_series = [];
          const delivery_alone_rate_series = [];
          const delivery_alone_count_series = [];
          this.data.forEach(el => {
            x_axis.push(this.showModal === 'team' ? el.team_name : el.nickname);
            task_count_series.push(el.task_count);
            delivery_alone_rate_series.push(el.delivery_alone_rate);
            delivery_alone_count_series.push(el.delivery_alone_count);
          });
          this.option.xAxis.data = x_axis;
          this.option.series = [
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '任务总数',
              data: task_count_series
            },
            {
              type: 'bar',
              label: {
                show: true,
                position: 'top'
              },
              name: '任务独立交付数',
              data: delivery_alone_count_series
            },
            {
              type: 'line',
              label: {
                show: true,
                position: 'top',
                formatter: '{c}%'
              },
              name: '独立交付率',
              data: delivery_alone_rate_series,
              yAxisIndex: 1
            }
          ];
          this.loading = false;
          this.drawChart();
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onDetail(index) {
      this.index = index;
      this.$refs.taskListModal.open();
    },
    close() {
      this.detailVisible = false;
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
